import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';
import { handleErrorMessage, getUserNameAndSurname } from '../../utils';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForUpdateRequestCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: null,
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  changeComboAutocomplete = (value) => {
    this.setState({ client: value });
  };

  handleClientValidation = () => {
    let hasError = false;
    let errors = {};
    const { Errors } = this.props.t || {};

    if (!this.state.client) {
      errors['client'] = Errors.client;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation()) {
      return;
    }

    const requestWithNewRequestclient = {
      ...this.props.requestForSignetApproval,
      client: this.state.client,
    };

    this.props.handleRequestUpdate(requestWithNewRequestclient);
  };

  render() {
    const { error, t, usersByKJSMunicipality, currentRequestClient } =
        this.props || {},
      { Labels, Placeholders } = t || {};

    const clientAlts =
      usersByKJSMunicipality?.filter(
        (user) => user?.id !== currentRequestClient?.id
      ) || [];

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{Labels.title}</h5>
            <form noValidate onSubmit={this.handleSubmit}>
              <Row className="mb-4 mt-5">
                <Col md={12}>
                  <ComboBoxAutocomplete
                    data={clientAlts}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete(newValue)
                    }
                    placeholder={Placeholders.client}
                    text={(newRequestClient) =>
                      getUserNameAndSurname(newRequestClient)
                    }
                    required
                    wholeObject
                    updateValue={this.state.client}
                    error={handleErrorMessage(
                      error,
                      'client',
                      this.state.errors.client
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <ButtonSave onClick={this.handleSubmit} />
              </Row>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForUpdateRequestCreator,
  'ModalForUpdateRequestCreator'
);
